<template>
  <v-container class="fill90vh">
    <v-row class="fill90vh" align="center" justify="center">
      <v-btn
        small
        rounded
        color="secondary"
        class="mx-3"
        :disabled="isAuthenticated"
        @click="signIn"
        >Authorize</v-btn
      >
      <v-btn
        small
        rounded
        color="secondary"
        class="mx-3"
        :disabled="!isAuthenticated"
        @click="signOut"
        >SignOut</v-btn
      >
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
import * as d3 from "d3";
import getsheetobj from "@/mixins/getsheetobj";

export default {
  name: "Home",
  mixins: [getsheetobj],
  computed: {
    ...mapState({
      isAuthenticated: (state) => state.auth.isAuthenticated,
      authenticatedUser: (state) => state.auth.authenticatedUser,
      sheetId: (state) => state.sheet.sheetId,
      allSheets: (state) => state.sheet.allSheets,
      sheetsObj: (state) => state.sheet.sheetsObj,
      totals: (state) => state.sheet.totals,
    }),
  },
  methods: {
    ...mapActions({
      setAuthStatusAct: "auth/setAuthStatus",
      setAuthUserAct: "auth/setAuthUser",
      updateSheetsObjAct: "sheet/updateSheetsObj",
    }),
    async signIn() {
      const gapic = await this.$gapi.getGapiClient(); // init client
      // Check if user is already signed in
      const isSignedIn = await gapic.auth2.getAuthInstance().isSignedIn.get();
      if (isSignedIn === false) {
        try {
          // Sign in user
          await gapic.auth2.getAuthInstance().signIn();
          // Get new isSignedIn status
          const isSignedIn = await gapic.auth2
            .getAuthInstance()
            .isSignedIn.get();
          // invoke action in the store to set isAuth to isSignedIn or true
          this.setAuthStatus(isSignedIn);
          const authUser = await gapic.auth2.getAuthInstance().currentUser.get()
            .Qt.Au;
          // console.log("authUser: ", authUser);
          // invoke action to set the authUser in store
          this.setAuthUser(authUser);
          if (this.authenticatedUser === "me@ameerabbas.com") {
            this.getAllSheetsObj(this.sheetId, this.allSheets);
          } else {
            console.log("user not allowed!")
            this.signOut()
          }
        } catch (err) {
          console.error("There was an error signing in: ", err);
        }
      } else {
        // If user is already logged in
        console.log(`user ${this.authenticatedUser} is already logged in!`);
      }
    },
    async signOut() {
      const gapic = await this.$gapi.getGapiClient();
      // Check if user is signed in
      const isSignedIn = await gapic.auth2.getAuthInstance().isSignedIn.get();
      if (isSignedIn === true) {
        try {
          // sign out
          await gapic.auth2.getAuthInstance().signOut();
          // confirm status
          const isSignedIn = await gapic.auth2
            .getAuthInstance()
            .isSignedIn.get();
          // invoke action to set isAuthenticated value in store
          this.setAuthStatus(isSignedIn);
          // invoke action to set user to null
          this.setAuthUser("");
          const sheetsObj = {};
          this.updateSheetsObj(sheetsObj);
        } catch (err) {
          console.error("There was an error signing out: ", err);
        }
      } else {
        console.log("No user is logged in!");
      }
    },
    setAuthStatus(authStatus) {
      this.setAuthStatusAct(authStatus);
    },
    setAuthUser(authUser) {
      this.setAuthUserAct(authUser);
    },
    async TEMPcopyMoneyFoodActivity19() {
      // Copy and reformat 'money', 'activityFood' and 'activityLife' tabs from NU'MONEY19 sheet
      // to 'money', 'food', 'activity' tabs in the 2NULIFEDEV sheet
      const numoney19SheetId = "1ff3IwyaVkttchrR1WaQ6fk_z4nPpFWhh4FQ1tjsXCsc";
      const twonulifedevSheetId =
        "1qw8sW9TG4oNqy2UR32L6ee91M7_1P0zg1WiJ9GYAOw8";

      const oldmoneySheetName = "activityMoney";
      const oldfoodSheetName = "activityFood";
      const oldactivitySheetName = "activityLife";

      const alloldSheetNames = [
        oldmoneySheetName,
        oldfoodSheetName,
        oldactivitySheetName,
      ];

      const newmoneySheetName = "money";
      const newfoodSheetName = "food";
      const newactivitySheetname = "activity";

      // const allnewSheetNames = [newmoneySheetName, newfoodSheetName, newactivitySheetname]

      const newmoneyHeaderRow = [
        "id",
        "uuid",
        "date",
        "category",
        "vendor",
        "type",
        "tags",
        "description",
        "source",
        "method",
        "receipt",
        "trip",
        "tax",
        "business",
        "amount",
      ];
      const newfoodHeaderRow = [
        "id",
        "uuid",
        "date",
        "time",
        "description",
        "type",
        "trip",
        "health",
      ];
      const newactivityHeaderRow = [
        "id",
        "uuid",
        "date",
        "time",
        "name",
        "duration",
        "totals",
        "reps",
        "exercise",
        "muscleGroup",
        "feel",
      ];

      if (this.isAuthenticated) {
        try {
          const gapic = await this.$gapi.getGapiClient(); // init client
          await new Promise((r) => setTimeout(r, 500)); // wait half second
          const numoney19Response = await gapic.client.sheets.spreadsheets.values.batchGet(
            {
              spreadsheetId: numoney19SheetId,
              ranges: alloldSheetNames,
            }
          );
          const oldmoneyArray = numoney19Response.result.valueRanges[0].values;
          const oldfoodArray = numoney19Response.result.valueRanges[1].values;
          const oldactivityArray =
            numoney19Response.result.valueRanges[2].values;

          let newMoneyArray = [];
          let newFoodArray = [];
          let newActivityArray = [];
          newMoneyArray.push(newmoneyHeaderRow);
          newFoodArray.push(newfoodHeaderRow);
          newActivityArray.push(newactivityHeaderRow);

          let moneyId = 1;
          oldmoneyArray.forEach((row, index) => {
            if (!(index === 0)) {
              let rowData = [];
              if (row[7]) {
                rowData = [];
                rowData.push(moneyId); // id
                rowData.push(uuidv4()); // uuid
                rowData.push(row[1]); // date
                rowData.push(row[2]); // category
                rowData.push(row[3]); // vendor
                rowData.push(row[4]); // type
                rowData.push(""); // tags
                rowData.push(row[5]); // detail
                rowData.push(row[7]); // paySource
                rowData.push(row[8]); // method
                rowData.push(row[9]); // receipt
                rowData.push(row[10]); // trip
                rowData.push(row[12]); // tax
                rowData.push(row[13]); // business
                rowData.push(parseFloat(row[6])); // amount
                newMoneyArray.push(rowData);
                moneyId += 1;
              }

              if (row[11]) {
                rowData = [];
                let amount = -1 * parseFloat(row[6]);
                rowData.push(moneyId); // id
                rowData.push(uuidv4()); // uuid
                rowData.push(row[1]); // date
                rowData.push(row[2]); // category
                rowData.push(row[3]); // vendor
                rowData.push(row[4]); // type
                rowData.push(""); // tags
                rowData.push(row[5]); // detail
                rowData.push(row[11]); // paySink
                rowData.push(row[8]); // method
                rowData.push(row[9]); // receipt
                rowData.push(row[10]); // trip
                rowData.push(row[12]); // tax
                rowData.push(row[13]); // business
                rowData.push(amount); // amount
                newMoneyArray.push(rowData);
                moneyId += 1;
              }
            }
          });
          const moneyParams = {
            spreadsheetId: twonulifedevSheetId,
            valueInputOption: "RAW",
            range: newmoneySheetName,
          };
          const moneyvalueRangeBody = {
            majorDimension: "ROWS",
            values: newMoneyArray,
          };
          await gapic.client.sheets.spreadsheets.values.update(
            moneyParams,
            moneyvalueRangeBody
          );

          let foodId = 1;
          oldfoodArray.forEach((row, index) => {
            if (!(index === 0)) {
              let rowData = [];
              let foodHealth;
              if (parseFloat(row[6]) <= 20) {
                foodHealth = 0;
              } else if (parseFloat(row[6]) <= 40) {
                foodHealth = 1;
              } else if (parseFloat(row[6]) <= 60) {
                foodHealth = 2;
              } else if (parseFloat(row[6]) <= 80) {
                foodHealth = 3;
              } else if (parseFloat(row[6]) <= 100) {
                foodHealth = 4;
              }

              rowData.push(foodId); // id
              rowData.push(uuidv4()); // uuid
              rowData.push(row[1]); // date
              rowData.push(row[2]); // time
              rowData.push(row[3]); // description
              rowData.push(row[4]); // type
              rowData.push(row[5]); // trip
              rowData.push(foodHealth); // health
              newFoodArray.push(rowData);
              foodId += 1;
            }
          });
          const foodParams = {
            spreadsheetId: twonulifedevSheetId,
            valueInputOption: "RAW",
            range: newfoodSheetName,
          };
          const foodvalueRangeBody = {
            majorDimension: "ROWS",
            values: newFoodArray,
          };
          await gapic.client.sheets.spreadsheets.values.update(
            foodParams,
            foodvalueRangeBody
          );

          oldactivityArray.forEach((row, index) => {
            if (!(index === 0)) {
              let rowData = [
                row[0],
                uuidv4(),
                row[1],
                row[2],
                row[3],
                row[4],
                row[5],
                row[6],
                row[7],
                row[8],
              ];
              let activityFeel;
              if (parseFloat(row[9]) <= 20) {
                activityFeel = 0;
              } else if (parseFloat(row[9]) <= 40) {
                activityFeel = 1;
              } else if (parseFloat(row[9]) <= 60) {
                activityFeel = 2;
              } else if (parseFloat(row[9]) <= 80) {
                activityFeel = 3;
              } else if (parseFloat(row[9]) <= 100) {
                activityFeel = 4;
              }
              if (!row[9]) {
                activityFeel = "";
              }
              rowData.push(activityFeel);
              newActivityArray.push(rowData);
            }
          });
          const activityParams = {
            spreadsheetId: twonulifedevSheetId,
            valueInputOption: "RAW",
            range: newactivitySheetname,
          };
          const activityvalueRangeBody = {
            majorDimension: "ROWS",
            values: newActivityArray,
          };
          await gapic.client.sheets.spreadsheets.values.update(
            activityParams,
            activityvalueRangeBody
          );
        } catch (err) {
          console.error("copyMoneyFoodActivity19Error: ", err);
        }
      }
    },
    async calculateTotals() {
      // rando totals
      const moneyTotals = d3
        .nest()
        .key((d) => d.source)
        .rollup((v) => d3.sum(v, (d) => d.amount))
        .entries(this.sheetsObj.money.data);

      const exerciseTotals = d3
        .nest()
        .key((d) => d.exercise)
        .rollup((v) => d3.sum(v, (d) => d.reps))
        .entries(this.sheetsObj.activity.data);

      const muscleGroupTotals = d3
        .nest()
        .key((d) => d.muscleGroup)
        .rollup((v) => d3.sum(v, (d) => d.reps))
        .entries(this.sheetsObj.activity.data);

      this.$store.dispatch("sheet/updateSheetsState", {
        state: "totals",
        field: "money",
        value: moneyTotals,
      });
      this.$store.dispatch("sheet/updateSheetsState", {
        state: "totals",
        field: "activity",
        subfield: "exercise",
        value: exerciseTotals,
      });
      this.$store.dispatch("sheet/updateSheetsState", {
        state: "totals",
        field: "activity",
        subfield: "muscleGroup",
        value: muscleGroupTotals,
      });
    },
  },
  async mounted() {
    const gapic = await this.$gapi.getGapiClient(); // init client
    // get isSignedIn
    const isSignedIn = await gapic.auth2.getAuthInstance().isSignedIn.get();
    // invoke action to set isAuth in store
    this.setAuthStatus(isSignedIn);
    if (isSignedIn) {
      const authUser = await gapic.auth2.getAuthInstance().currentUser.get();
      // If signedIn, invoke action to set authUser in store
      this.setAuthUser(authUser);
      await this.getAllSheetsObj(this.sheetId, this.allSheets);
      this.getEditFormFields(this.sheetId, this.allSheets);
      // this.TEMPcopyMoneyFoodActivity19(); // Only when need to copy from NU'MONEY19 to 2LIFEDEV sheet
      this.calculateTotals(); // Calc totals brah
    } else {
      // if not SignedIn, invoked action to set authUser in store to null
      this.setAuthUser("");
    }
  },
};
</script>

<style lang="scss" scoped>
.fill90vh {
  height: 90vh;
}
</style>
